<template>
  <div class="intro-item">
      <slot></slot>
      <h2 class="intro-item-title">
        <slot name="title"></slot>
      </h2>
      <h2 class="intro-item-subtitle">
        <slot name="subtitle"></slot>
      </h2>
  </div>
</template>

<script>
export default {
  name: 'IntroduceItem',
}
</script>

<style lang="less" scoped>
@import "../../../assets/style/styleMixins";

.intro {
  &-item {
    .flex_center_mixins;
    width: 33%;
    flex-direction: column;
    margin-top: 40px;
    & > img{
      width: 80px;
      height: 80px;
    }
    &-title{
      font-size: 18px;
      color: #333333;
      margin: 20px 0;
    }
    &-subtitle{
      font-size: 14px;
      color: #666666;
      line-height: 24px;
      width: 238px;
    }
  }
}
</style>
